import { combineReducers } from 'redux'
import calendar from './calendar.reducer'
import filter from './filter.reducer'

export default combineReducers({
  calendar,
  filter
})
